import { useState, useEffect } from "react"
import { useNavigate } from "react-router"
import { toast } from "react-toastify"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import { years_list, months_list } from "../../Shared/List";
import {InputField, NullableInput} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const AddEmployeeCommissionForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [employeeOptions, setEmployeeOptions] = useState([])
    const [yearOptions, setYearOptions] = useState([]);
    const [monthOptions, setMonthOptions] = useState([])
    const current_user = JSON.parse(localStorage.getItem('user'))
    const billing_date  = current_user?.branch?.billing_date

    const [formData, setFormData] = useState({
        employee_id: "",
        debit: "",
        remark: "",
        rate: 1,
        year: billing_date.year,
        month: billing_date.month,
        date: new Date().toISOString().slice(0, 10),
    })
    const {employee_id, debit, remark, date, rate, year, month} = formData

    const navigate = useNavigate();

    useEffect(() => {

        const years = []
        const months = []
        years_list.map(year => (
            years.push({
                id: year.id,
                name: year.name,
                key: year.key
            })
        ))

        months_list.map(month => (
            months.push({
                id: month.id,
                name: month.name,
                key: month.key
            })
        ))

        setYearOptions(years)
        setMonthOptions(months)
        
    }, []);

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const loadOptions = async (url, query, setOptions) => {
        try {
            const params = { q: query };

            const response = await Server.get(`/options/${url}`, { params });
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onSubmit = (e) => {
        e.preventDefault()

        const payload = {employee_id, debit, remark, date, rate, year, month}
        addCommission(payload)
    }
    
    // debit employee
    const addCommission = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/payrolls/employee-commision', payload)
            toast.success(response.data?.detail)
            navigate('/payrolls')
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Add Employee Commission Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-2">
                            <SelectField
                                name="year"
                                label="Year"
                                value={parseInt(year)}
                                options={yearOptions}
                                onChange={onChange}
                                error={errors.year}
                            />
                        </div>
                        <div className="col-md-2">
                            <SelectField
                                name="month"
                                label="Month"
                                value={parseInt(month)}
                                options={monthOptions}
                                onChange={onChange}
                                error={errors.month}
                            />
                        </div>
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="employee_id"
                                label="Employee"
                                value={employee_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('employees', query, setEmployeeOptions)}
                                options={employeeOptions}
                                placeholder="Start typing to search..."
                                error={errors.employee_id}
                            />
                        </div>
                        <div className="col-md-2">
                            <InputField
                                name="debit"
                                type="number"
                                label="Debit"
                                value={debit}
                                onChange={onChange}
                                error={errors.debit}
                            />
                        </div>
                        <div className="col-md-2">
                            <InputField
                                name="rate"
                                type="number"
                                label="Rate"
                                value={rate}
                                onChange={onChange}
                                error={errors.rate}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                                max={new Intl.DateTimeFormat('en-CA').format(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0))}
                            />
                        </div>
                        <div className="col-md-8">
                            <NullableInput
                                placeholder="Remark (Optional)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Save Transaction" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default AddEmployeeCommissionForm
